import { SvgIcon, } from "@material-ui/core";
import React from "react";

const StarIcon = (props) => {

  return (
    React.createElement(SvgIcon, { ...props,}
      , React.createElement('path', { d: "M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.62L10 0L7.19 6.62L0 7.24L5.45 11.97L3.82 19L10 15.27Z"           ,} )
    )
  )
};

export default StarIcon;